import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { EditAttractionFormDataType } from "@/dialogs/attractions/EditAttractionDialog"

function useEditAttraction(attractionId: number) {
  return useMutation({
    mutationFn: (data: EditAttractionFormDataType) => {
      return client
        .put(`/attractions/${attractionId}`, data)
        .then((response) => response.data)
    },
  })
}
export default useEditAttraction
